import React from 'react';
import Autosuggest from 'react-autosuggest';
import {TextField,MenuItem, InputAdornment} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles} from '@material-ui/core';
const styles = theme => ({
  root: { flexGrow: 1, },
  container: { position: 'relative', zIndex: 101, },
  suggestionsContainerOpen: { position: 'absolute', zIndex:1, marginTop: theme.spacing(0), left: 0, right: 0, backgroundColor: '#fff', },
  suggestionsList: { margin: 0, padding: 0, zIndex:1, listStyleType: 'none', display:"block !important", wordBreak:"break-all",whiteSpace:"pre-wrap !important",
  maxHeight:220, overflow:"auto", boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)" },
  divider: { height: theme.spacing(2), },
});

const getSuggestions = (value,list) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  return  inputLength === 0 ? [] : list.filter(obj =>
    (`${obj.resourceid}`.toLowerCase().includes( inputValue))
  );
};


const getSuggestionValue = suggestion => suggestion.resourceid;

const renderSuggestion = suggestion => {
  return ( <MenuItem className="searchResultList"> {`${suggestion.resourceid}`} </MenuItem> );
};
let renderInputComponent = function (inputProps){
    const { classes,...other } = inputProps;
    return (
      <TextField
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: ( <InputAdornment position="start"> <SearchIcon /> </InputAdornment> ),
          style: { backgroundColor: "#fff", minHeight: "54px" },
          classes: { input: "searchInput", },
        }}
        {...other}
      />

    );
  };
class Seacrh extends React.Component {
  constructor() {
    super();
    this.state = {
      value: '',
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
    if(newValue===""){
      this.props.filterPatientList(this.props.list);
    }
  };

  onSuggestionsFetchRequested = async({ value }) => {
    if(value){
      let filteredList = await getSuggestions(value,this.props.list);
      this.setState({
        suggestions: filteredList
      });
      return filteredList;
    } else{
      return this.props.list;
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  onSuggestionSelected = (event,{suggestion})=>{
      this.setState({value:`${suggestion.resourceid}`});
      this.props.filterPatientList([suggestion]);
  };
  async componentDidUpdate(prevProps){
    if(prevProps.list !== this.props.list){
      let filteredList = await this.onSuggestionsFetchRequested({value:this.state.value});
      this.props.filterPatientList(filteredList);
   }
    if(prevProps.reqAttentionFilter !== this.props.reqAttentionFilter){
      this.setState({value:""});
    }
}
  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      onChange: this.onChange,
      placeholder: 'Search',
      value
    };

    const autosuggestProps = {
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        onSuggestionSelected:this.onSuggestionSelected,
        getSuggestionValue,
        renderSuggestion,
        renderInputComponent
      };
      return (
        <Autosuggest
          {...autosuggestProps}
          theme={{
            container: this.props.classes.container,
            suggestionsContainerOpen: this.props.classes.suggestionsContainerOpen,
            suggestionsList: this.props.classes.suggestionsList,
            suggestion: this.props.classes.suggestion,
          }}
          getSuggestionValue={getSuggestionValue}
          inputProps={inputProps}
        />
    );
  }
}

export default (withStyles(styles)(Seacrh));